import merge from 'lodash/merge'

export default {
  save: ({ state, dispatch, commit, getters, rootState, rootGetters }) => {
    return dispatch('preSaveActions')
      .then(() => dispatch('saveToThesaurum'))
  },
  saveToThesaurum: ({ dispatch, getters, rootGetters }) => {
    const blobID = 'concilio--site-settings'
    const blobData = rootGetters['blob/get']('concilio--site-settings')

    const settings = getters.settings
    const saveData = merge({}, blobData, { sitegateSettings: settings })

    return dispatch('blob/save', { blobID: blobID, blobData: saveData }, { root: true })
  },
  preSaveActions: ({ dispatch }, payload) => {
    return Promise.all([
      dispatch('updateSaveTimestamp'),
      dispatch('checkForcedInvalidation')
    ])
  },
  checkForcedInvalidation: ({ dispatch, state, commit, getters }) => {
    const settings = getters.settings

    return Object.keys(settings).map((settingKey) => {
      if (Object.keys(settings[settingKey]).includes('configuration') && settings[settingKey].configuration.forcedInvalidation) {
        return dispatch('setInvalidationTimestamp', settingKey)
          .then((settingKey) => dispatch('resetSitegateInvalidation', settingKey))
      }
    })
  },
  updateSaveTimestamp: ({ state, commit }) => {
    return commit('SET_SITEGATE_SETTINGS_TIMESTAMP', new Date().toUTCString())
  },
  setInvalidationTimestamp: ({ state, commit }, payload) => {
    const timestamp = new Date().toUTCString()
    commit('SET_SITEGATE_INVALIDATION_TIMESTAMP', { gate: payload, timestamp: timestamp })

    return payload
  },
  resetSitegateInvalidation: ({ commit }, payload) => {
    return commit('RESET_SITEGATE_INVALIDATION', payload)
  },
  updateConfiguration: ({ state, commit, getters }, payload) => {
    commit('UPDATE_CONFIGURATION_SETTINGS', payload)
  },
  updateContent: ({ state, commit, getters }, payload) => commit('UPDATE_CONTENT_SETTINGS', payload),
  updateStyles: ({ state, commit, getters }, payload) => commit('UPDATE_STYLE_SETTINGS', payload),
  updateGateType: ({ state, commit, getters }, payload) => {
    const gateDefaultSettings = getters.defaults(payload)
    const gateStyleSettings = merge({}, gateDefaultSettings.styles, getters.styleSettings)
    const gateContentSettings = merge({}, gateDefaultSettings.content, getters.contentSettings)

    commit('UPDATE_TYPE', payload)
    commit('UPDATE_STYLES', gateStyleSettings)
    commit('UPDATE_CONTENT', gateContentSettings)
  },
  updateInitialLoadAgeGate: ({ state, commit }, payload) => {
    commit('CHANGE_INITIAL_LOAD_SITE_GATE', payload)
  },
  init({ state, commit, dispatch, rootGetters, rootState }, { payload, eventHub }) {
    const blobData = rootGetters['blob/get']('concilio--site-settings')
    const defaultSettings = JSON.parse(JSON.stringify(state.defaultSettings))

    const ageGateAvailable = rootState.registry.getFeature('age-gate')

    if (ageGateAvailable) {
      defaultSettings.configuration.initialLoadGate = 'age-gate'
    }

    const storeSettings = (Object.keys(blobData).length > 0 && Object.keys(blobData).includes('sitegateSettings')) ? merge({}, defaultSettings, blobData.sitegateSettings) : defaultSettings

    commit('UPDATE_SITEGATE_SETTINGS', storeSettings)

    if (process.env.SERVER_BUILD === 'ssr') return

    if (payload['account-activated'] && rootState.registry.isUV()) {
      if (payload['account-activated'] === 'error' || !payload['activation-token']) {
        commit('SET_ACTIVATION_STATUS', 'error')
        return
      }

      return fetch(`${rootState.registry.getServiceEndpoint('datastore')}/vuejs/user/login-token`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          'AuthToken': payload['activation-token']
        })
      })
        .then(resp => resp.json())
        .then(({ data }) => {
          if (!data['jwt']) {
            commit('SET_ACTIVATION_STATUS', 'error')
            return
          }

          return this.dispatch('showProgressLoader')
            .then(_ => this.dispatch('user/injectAuthJWT', data['jwt']))
            .then(_ => {
              if (rootGetters['user/isLoggedIn']) {
                eventHub.$emit('loginComplete')
                commit('SET_ACTIVATION_STATUS', 'success')
              }
            })
            .catch(_ => {
              commit('SET_ACTIVATION_STATUS', 'error')
            })
            .finally(_ => this.dispatch('hideProgressLoader'))
        })
    }
  }
}
